import React from 'react';
import PropTypes from 'prop-types';
import BaseNext from '../base-next';

const City = props => {
  const {
    onChange,
    value,
    error,
    touched,
    onBlur,
    id,
    isDisabled,
    setCityAutocompleteState,
    isCosigner,
    hideErrorMessage
  } = props;

  return (
    <BaseNext
      isDisabled={isDisabled}
      data-cv-test="addressCity"
      onChange={e => {
        setCityAutocompleteState('manual');
        onChange(e);
      }}
      onBlur={onBlur}
      value={value}
      touched={touched}
      error={error}
      id={id}
      text="text"
      labelText="City"
      maxLength={101}
      isCosigner={isCosigner}
      hideErrorMessage={hideErrorMessage}
    />
  );
};

City.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  touched: PropTypes.bool,
  isDisabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  id: PropTypes.string,
  setCityAutocompleteState: PropTypes.func,
  isCosigner: PropTypes.bool
};

City.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  value: '',
  touched: false,
  error: false,
  isDisabled: false,
  id: '',
  setCityAutocompleteState: () => {},
  isCosigner: false
};

export default City;
